import {useQuery} from "@tanstack/react-query";
import {createAdjustmentCode} from "../../../../../api/inventory/AdjustmentApi";

export const useCreateAdjustmentCode = () => {
    const {data} = useQuery({
        queryKey: ["createAdjustmentCode"],
        queryFn: async () => await createAdjustmentCode(),
        select: (res) => res?.data.result?.adjustmentCode ?? "",
    });

    return {data};
};
